import { Link } from "react-router-dom";

import { Logo } from "@/components/atoms/Logo";
import { cn } from "@/components/ui/utils";
import { Navigation } from "@/constants";

export function SharedReportLogo({ embedded = false }: { embedded?: boolean }) {
  return (
    <Link
      to={Navigation.ROUTES.PAGE}
      aria-label="Neoledger home"
      className={cn(
        "flex items-center shrink-0 [color:inherit] no-underline",
        embedded
          ? "justify-start h-auto pl-0 pr-0"
          : "justify-start md:justify-center h-full min-h-12 pl-4 pr-4 md:pl-2 md:pr-2",
      )}
    >
      <Logo variant="logo-only" size="md" />
    </Link>
  );
}
